import styled from 'styled-components';
import DropDown from '@/trio-ui/Dropdown';

export const Box = styled.div`
  display: flex;
  flex: 1;
  padding: 12px;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors['neutral-30']};
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex: 0.8;
`;

export const Label = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
  max-width: 98%;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex: 0.2;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  flex: 0.2;
  justify-content: left;
`;

export const CustomDropdown = styled(DropDown)`
  width: 100%;
  padding-bottom: ${(props) => (props.errorMessage ? 12 : 0)}px;
`;

export const MaxScoreValue = styled.em`
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-70']};
`;
